export default __webpack_public_path__ + "static/media/site-blog.472edd41.svg";